import React, { useMemo } from 'react';
import { Flex, ResponsiveValue } from '@chakra-ui/react';

import { useFilters, styles, useCalendarSettings, useShortcodeSettings } from '../../../../../lib';
import { SearchFilter } from '../';
import { UnifiedFilterPill } from './UnifiedFilterPill';
import { __ } from '../../../../../lib/i18n';

export const RenderHorizontalFilters = () => {
	const { filters, defaultFilters, handleApplyFilters } = useFilters();
	const { settings } = useCalendarSettings();
	const { settings: shortcodeSettings } = useShortcodeSettings();

	const { enableSearchFilter, enableLocationFilter, enableCategoryFilter, enableVenueFilter, enableTagFilter } =
		settings;
	const showFilters = shortcodeSettings.filters;

	const filterConfigs = useMemo(
		() => [
			{
				filterKey: 'selectedEventTypes',
				label: __('Categories'),
				options: defaultFilters.eventTypes,
				selectedOptions: filters.selectedEventTypes,
				isMulti: true,
				showColors: true,
				isEnabled: !shortcodeSettings.cat && (showFilters || enableCategoryFilter),
			},
			{
				filterKey: 'selectedEventLocations',
				label: __('Venues'),
				options: defaultFilters.eventLocations,
				selectedOptions: filters.selectedEventLocations,
				isMulti: true,
				isEnabled: !shortcodeSettings.venue && (showFilters || enableVenueFilter),
			},
			{
				filterKey: 'selectedEventTags',
				label: __('Tags'),
				options: defaultFilters.eventTags,
				selectedOptions: filters.selectedEventTags,
				isMulti: true,
				isEnabled: !shortcodeSettings.tag && (showFilters || enableTagFilter),
			},
			{
				filterKey: 'selectedCountries',
				label: __('Country'),
				options: defaultFilters.countries,
				selectedOptions: filters.selectedCountries,
				isMulti: false,
				isEnabled: showFilters || enableLocationFilter,
			},
			{
				filterKey: 'selectedStates',
				label: __('State'),
				options: defaultFilters.states,
				selectedOptions: filters.selectedStates,
				isMulti: false,
				disabled: !filters.selectedCountries.length,
				isEnabled: showFilters || enableLocationFilter,
			},
			{
				filterKey: 'selectedCities',
				label: __('City'),
				options: defaultFilters.cities,
				selectedOptions: filters.selectedCities,
				isMulti: false,
				disabled: !filters.selectedStates.length || !filters.selectedCountries.length,
				isEnabled: showFilters || enableLocationFilter,
			},
		],
		[
			filters,
			defaultFilters,
			showFilters,
			enableLocationFilter,
			enableTagFilter,
			enableVenueFilter,
			enableCategoryFilter,
			shortcodeSettings.cat,
			shortcodeSettings.venue,
			shortcodeSettings.tag,
		]
	);

	const { filterPillsWrap } = styles.filters;
	return (
		<Flex direction='column' gap={4} w='full' paddingBlock={4}>
			{(showFilters || enableSearchFilter) && <SearchFilter onApplyFilters={handleApplyFilters} />}
			<Flex gap={2} flexWrap={filterPillsWrap as ResponsiveValue<'wrap' | 'nowrap'>}>
				{filterConfigs
					.filter((filter) => filter.isEnabled)
					.map((config) => (
						<UnifiedFilterPill key={config.filterKey} {...config} onApplyFilters={handleApplyFilters} />
					))}
			</Flex>
		</Flex>
	);
};
